import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComments } from '@fortawesome/free-solid-svg-icons';
import ClockIcon from 'images/pu/products/usa_pcb_assembly/icons_clock.svg'
import map from 'images/pu/products/mx_pcb_assembly/map.png'
import EmailQuote from 'pu-react/components/EmailQuote';
import PriceMatrix from 'pu-react/components/PriceMatrix';

import { ERROR } from 'pu-data/QuoteSteps';
import PriceMatrixCell from 'mx_pcb_assembly/components/PriceMatrixCell';
import { priceSelected, doEmailQuote } from 'mx_pcb_assembly/store/slice';
import Error from 'product_tabs/tab_assembly/components/Error';

const Price = () => {
  const dispatch = useDispatch();
  const {
    quote,
    quoteStep,
    parameters,
    parametersChanged,
  } = useSelector((state) => state.mx_assembly);

  const onPriceSelect = (data) => dispatch(priceSelected(data));
  const onSendEmailQuote = (data, token) => dispatch(doEmailQuote({ data, token }));

  const lineItem = quote.line_items && quote.line_items[0]
  const restricted_price = lineItem.restricted_price;

  if (quoteStep == ERROR) {
    return (
      <Error />
    )
  }

  return (
    <div className="card border-0 mb-4">
      <div className="text-end p-3 pb-0">
        <EmailQuote
          quoteStep={quoteStep}
          parametersChanged={parametersChanged}
          parameters={parameters}
          onSendEmailQuote={onSendEmailQuote} />
      </div>

      <div className="card-body">
        <PriceMatrix
          tableSm
          tableStripe={false}
          lineItem={lineItem}
          supplier={lineItem.product_key}
          matrixCell={PriceMatrixCell}
          leadTimeText={(lt) => `${lt} weeks`}
          parametersChanged={parametersChanged}
          onPriceSelect={onPriceSelect}
          parameters={parameters}
          quoteStep={quoteStep}
          restricted_price={restricted_price} />
        <div>
          <p>
            <FontAwesomeIcon icon={faComments} id="custom-quote-icon" />
            &nbsp; If you could not get an online price you can request a &nbsp;
            <a className="link" href={Spree.routes.custom_quote_request_new_url}>custom quote</a>.
          </p>
          <ul>
            <li>First Article cost is included (Lead Time = 2 to 3 weeks).</li>
            <li>Production Lead Time starts after First Article is approved.</li>
            <li>To return the leftover parts and SMT Stencil, an additional customs fee (~$500.00) will be applied.</li>
          </ul>
        </div>
      </div>

      <div className="divider"></div>

      <div className="how-it-works">
        <div className="container">
          <div className="row no-gutters">
            <div className="col-12 col-lg-6">
              <h3 className="pt-3">How does it work?</h3>
              <ul>
                <li className="mb-3">All the material (PCBs and electronic components) are shipped to Calexico in the USA.</li>
                <li className="mb-3">The material is transported by land to Mexicali across the border.</li>
                <li className="mb-3">Your boards are assembled in Mexicali at a much lower cost.</li>
                <li className="mb-3">The assembled boards are transported back to Calixico and ship domestically to your location.</li>
              </ul>
            </div>
            <div className="col-12 col-lg-6 d-flex justify-content-center">
              <img src={map} alt="Calexico Map" className="img-fluid p-3" />
            </div>
          </div>
        </div>
      </div>

      <div className="assembly-clock">
        <div className="container">
          <div className="d-flex align-items-center">
            <div>
              <img src={ClockIcon} alt="Assembly Clock" />
            </div>
            <div>
              The Assembly Clock starts ticking the day after the PCBs,
              all the parts and required files are received.
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Price;